<template>
    <div v-show="show" class="dialog">
        <div class="mask fixed-100"></div>
        <div class="dialog-content">
            <div v-show="closeButton" class="close" @click="$emit('CloseEvent')">×</div>
            <h3>{{ title }}</h3>
            <div class="frame-wrapper" v-html="content"></div>
            <div class="text-center">
                <div class="primary-btn agree-btn" @click="$emit('OkEvent')">{{ okText }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        content: {
            type: String,
            default: '提示'
        },
        okText: {
            type: String,
            default: '确认'
        },
        closeButton: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            show: false
        }
    }
}
</script>

<style lang="scss" scoped>
.mask {
    z-index: 50001;
    background: rgba(0, 0, 0, 0.5);
}
.close {
    float: right;
    text-align: center;
    font-size: 80px;
    line-height: 50px;
    height: 50px;
    width: 50px;
    color: $gray;
    position: relative;
    right: 0;
    top: 0;
}
.dialog-content {
    position: fixed;
    padding: 20px;
    width: 80%;
    height: 80%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: 4px;
    background: #fff;
    z-index: 50002;
}
.frame-wrapper {
    height: calc(100% - 170px);
}
.agree-btn {
    margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/dialog/dialog.vue